// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3GxPw","rootSmall":"AddTileButton_rootSmall__2b4Mv"};